export const GetMarginTop = ({ widthWindow, marginTop }: { widthWindow: number; marginTop: number }) => {
  return widthWindow > 720 && widthWindow < 1440 ? `${marginTop / 14.4}vw` : `${marginTop}px`;
};
